import React from 'react';
import cn from 'classnames';
import TileHeader from './TileHeader';
import BondsTables from './BondsTables';
import { useTileContext } from '@/finsight/application/Bonds/TileContext';
import { ComposeBondsTileContext } from '@/finsight/application/Bonds/ComposeBondsTileContext';
import { useParentPageContext } from '@/finsight/application/ParentPageContext';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';
import { UserPlanType } from '@/users/domain/UserPlan';

import styles from './bondsTile.scss';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

const BondsTile = () => {
  const { isModuleEnabled } = useTileContext();

  if (!isModuleEnabled) {
    return null;
  }

  return (
    <div className={ cn(styles.container, spacesStyles.mtl) }>
      <TileHeader />
      <CheckUserPlanAccess
        requiredUserPlan={ UserPlanType.PRO }
        fallback={ null }
      >
        <BondsTables />
      </CheckUserPlanAccess>
    </div>
  );
};

export default (props) => {
  const { bondTileData } = useParentPageContext();

  return (
    <ComposeBondsTileContext
      bondTileData={ bondTileData }
    >
      <BondsTile { ...props } />
    </ComposeBondsTileContext>
  );
};
